const Tooltip = {
  baseStyle: {
    bg: "modal",
    color: "white"
  }
};

export default Tooltip;
